import { Injectable } from '@angular/core';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

@Injectable({ providedIn: 'root' })
export class HelperService {
  /** Returns 'YYYY-MM-DD' in the job's local timezone */
  getEffectiveScheduledDate(model: {
    startTimeUTC?: string | null;
    scheduledDate?: string | null;
    date?: string | null;
    timeZoneId?: string | null;
  }): string {
    // 1️⃣ Prefer valid UTC timestamp
    if (this.isValidUtc(model.startTimeUTC) && model.timeZoneId) {
      try {
        const utcDate = new Date(model.startTimeUTC!);
        const zoned = utcToZonedTime(utcDate, model.timeZoneId);
        return format(zoned, 'yyyy-MM-dd');
      } catch {
        // Fall through to legacy
      }
    }

    // 2️⃣ Legacy fallback (guaranteed to exist in your data)
    const legacy = model.scheduledDate ?? model.date;

    if (!legacy) {
      throw new Error('Missing both startTimeUTC and scheduledDate/date');
    }

    // Prevent JS timezone shifting of YYYY-MM-DD
    if (typeof legacy === 'string' && legacy.length >= 10) {
      return legacy.slice(0, 10);
    }

    const parsed = new Date(legacy);
    if (isNaN(parsed.getTime())) {
      throw new Error('Invalid legacy date value');
    }

    return format(parsed, 'yyyy-MM-dd');
  }

  /** Strict validation of real UTC timestamps */
  private isValidUtc(value?: string | null): boolean {
    if (!value) return false;

    const d = new Date(value);
    if (isNaN(d.getTime())) return false;

    // reject .NET defaults and uninitialized junk
    if (d.getFullYear() < 1971) return false;

    return true;
  }
}
